import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useLanguage } from '../../locale/useLanguage';
import { useAppDispatch, useAppSelector } from '../../redux/core';
import { authTokenSelector } from '../../redux/user/user.selectors';
import { Routes } from '../../routes/types';
import { TimesIcon } from '../Icons';
import {
  getAuthenticatedMenuElement,
  getAnonymousMenuElement,
} from './sideMenuHelpers';

import './SideMenu.css';

type SideMenuProps = {
  isMenuOpen: boolean;
  onCloseMenu: () => void;
};

export type MenuItem = {
  name: string;
  icon: ReactNode;
  link: Routes | null;
  action?: () => void;
};

export const SideMenu: React.FC<SideMenuProps> = ({
  isMenuOpen,
  onCloseMenu,
}) => {
  const [t] = useLanguage();
  const history = useHistory();

  const isAuthenticated = !!useAppSelector(authTokenSelector);

  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

  const menuClasses = isMenuOpen ? 'menu--open' : '';
  const overlayClass = isMenuOpen ? 'menu--open-overlay' : '';

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      setMenuItems(getAuthenticatedMenuElement(t, dispatch));
    } else {
      setMenuItems(getAnonymousMenuElement(t));
    }
  }, [dispatch, isAuthenticated, t]);

  const navigateToRoute = useCallback(
    (routes: Routes) => {
      history.push(routes);
    },
    [history]
  );

  return (
    <>
      <div onClick={onCloseMenu} className={`menu--overlay ${overlayClass}`} />
      <div className={`menu--wrapper ${menuClasses}`}>
        <header className="menu--navbar">
          <span className="menu--placeholder"></span>
          <h1 className="menu--title">Menu</h1>
          <button
            role="button"
            aria-label="Close"
            onClick={onCloseMenu}
            className="clickable menu--navbar-icon-button"
          >
            <TimesIcon width="24px" height="24px" className='layout--icon-color' />
          </button>
        </header>
        <div className="menu--body">
          {menuItems.map((elem, i) => {
            const { icon, name } = elem;

            return (
              <React.Fragment key={i}>
                {i !== 0 && <span className="menu--separator" />}
                <a
                  onClick={() => {
                    if (elem.link) {
                      navigateToRoute(elem.link);
                    }
                    elem.action?.();
                  }}
                  className="menu--item"
                >
                  <div className="menu--item-icon">{icon}</div>
                  <span className="menu--item-text">{name}</span>
                </a>
              </React.Fragment>
            );
          })}
          {/* <div className="menu--footer-container">
            <h3 className="menu--footer-title">{t('menu.otherPosteApps')}</h3>
            <div className="menu--separator" />
            <a className="menu--item-small">
              <span>BancoPosta</span>
            </a>
            <a className="menu--item-small">
              <span>PostePay</span>
            </a>
            <a className="menu--item-small">
              <span>Ufficio Postale</span>
            </a>
          </div> */}
        </div>
      </div>
    </>
  );
};
